export default __webpack_public_path__ + "static/media/chevron-left.543db937.svg";